import React from "react";
import { useMutation } from "react-query";
import { finishSubcase } from "./gateway";
import { queryClient } from "src/shared/services/QeuryClient/reactQueryClient";
import { enqueueSnackbar } from "notistack";
import { AxiosError } from "axios";
import { useTranslation } from "react-i18next";

export default function useFinalizeSubcase(
  subcase_id: number,
  setOpenFinishModal: React.Dispatch<React.SetStateAction<boolean>>,
) {
  const { t } = useTranslation();

  return useMutation({
    mutationFn: finishSubcase,
    onSuccess: () => {
      enqueueSnackbar(t("Η εργασία ολοκληρώθηκε με επιτυχία!"), {
        variant: "success",
      });
    },
    onError: (error: AxiosError<string>) => {
      enqueueSnackbar(error.response?.data, { variant: "error" });
    },
    onSettled: async () => {
      await queryClient.invalidateQueries(["subcase_diff", subcase_id]);
      await queryClient.invalidateQueries("manageCaseApplication");
      setOpenFinishModal(false);
    },
  });
}
